<!--
  联系客服
  lovi 2020-2-24
-->
<template>
  <div class="w100">
   <!-- <van-nav-bar
      :title="$t('common.contactServiceCustomer')"
      left-arrow
      @click-left="_back"
    />-->
    <div class="scroll-wrapper" style="top: 0.1rem">
      <iframe
        ref="mainContent"
        frameborder="0"
        :src="url"
        width="100%"
        height="100%"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "service",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      url: ""
    };
  },
  created() {
    this.customerAddr();
  },
  mounted() {},
  computed: {},
  methods: {
    customerAddr() {
      let vm = this;
      vm.$post("/app/index/customerAddr", {}, { loading: true }).then(res => {
        console.log("customerAddr", res);
        vm.url = res.customer_service_link;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped></style>
